var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "journey-connection-property-base",
    {
      attrs: {
        label: _vm.resource("JourneyBuilder_FilterSettings_StartDate"),
        forInput: "ConnectionStartDate"
      }
    },
    [
      _c("date-picker", {
        attrs: {
          id: "ConnectionStartDate",
          options: {
            clearButton: true,
            clearButtonIcon: "fas fa-times",

            required: false,
            typeable: false,

            disabledDates: {
              from: undefined,
              to: new Date(0)
            }
          }
        },
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }